import { render, staticRenderFns } from "./TaskNewDialog.vue?vue&type=template&id=605e1384&scoped=true"
import script from "./TaskNewDialog.vue?vue&type=script&lang=js"
export * from "./TaskNewDialog.vue?vue&type=script&lang=js"
import style0 from "./TaskNewDialog.vue?vue&type=style&index=0&id=605e1384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605e1384",
  null
  
)

export default component.exports